import React, { useState } from "react";
import YourRequest from "./YourRequest";
import RequestHistory from "./RequestHistory";

const Index: React.FC = () => {
  const [showHistory, setShowHistory] = useState(false);

  return (
    <div>
      {showHistory ? (
        <RequestHistory onBack={() => setShowHistory(false)} />
      ) : (
        <YourRequest onShowHistory={() => setShowHistory(true)} />
      )}
    </div>
  );
};

export default Index;
